
import { Component, Vue, Prop, Emit } from 'vue-property-decorator'

@Component({
    name: 'add-news-table'
})

/**
 * 
 * @prop    value   数据
 * @emit    change  更改状态
 * 
*/
export default class AddNewsTable extends Vue {
    @Prop({ required: true }) private value!: any[]

    private statusOptions = [
        { value: 1, label: '未通过' },
        { value: 2, label: '已通过' },
        { value: 3, label: '不用管' },
        { value: 4, label: '已处理' }
    ]

    @Emit('change')
    private onStatusChange(row: any, status: number) {
        return { row, status }
    }
}
